import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar";
import { Button } from "antd";
import IMAGES from "../../constants/images";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import EventCounter from "../../Component/EventCounter";
import TabSwitcher from "../../Component/TabSwitcher";
import ViewSwitcher from "../../Component/ViewSwitcher";
import AppointmentControls from "../../Component/AppointmentFilter";
import EventTabSwitcher from "../../Component/EventTabSwitcher";
import EventControl from "../../Component/EventControls";
import { getHref } from "../../utils/navigation";
export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [activeTab, setActiveTab] = useState("Upcoming");
  const [activeView, setActiveView] = useState("grid");
  const [selectedType, setSelectedType] = useState("all");
  const [filteredAppointment, setFilteredAppointment] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleExport = () => {
    const selectedData = Object.values({} || {})
      .flat()
      .filter((item) => selectedRows.includes(item.appointmentId));

    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, "appointments.xlsx");
  };

  return (
    <div className="flex gap-2 bg-[#F8FAFC] min-h-screen mt-[80px]">
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] rounded-2xl">
          {/* Header */}
          <div className="max-w mx-auto p-2 mb-1">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
              <div>
                <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
                  Events
                </h1>
                <p className="text-xs text-[#64748B] font-poppins mt-0.5 mb-0">
                  Plan, host and track your webinars and camps.
                </p>
              </div>
              <div className="flex items-center gap-2">
                {selectedRows.length > 0 ? (
                  <Button
                    onClick={handleExport}
                    className="flex items-center gap-2 px-[14px] py-0 bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition h-9 hover:text-[#171717]"
                  >
                    {/* <ArrowUpTrayIcon className="h-5 w-5" /> */}
                    Export
                    <img
                      src={IMAGES.export_icon}
                      alt="export_icon"
                      className="w-[18px]"
                    />
                  </Button>
                ) : null}
                <a
                  href={getHref("/createEvent")}
                  className="flex justify-center items-center btn-gradient text-[#FFFFFF] font-poppins text-[13px] font-semibold h-9 rounded-xl no-underline px-[14px] shadow-sm"
                >
                  <img
                    src={IMAGES.create_followup}
                    alt="request reschedule"
                    className="w-[16px] h-[16px] mr-2 font-poppins"
                  />
                  {"Create Event"}
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-3 p-2">
            {/* Left Side */}
            <div className="flex-1 min-w-0">
              <div className="mt-0">
                <EventCounter />
              </div>
            </div>
            {/*Right Side*/}
            <div className="w-full lg:w-1/4 lg:min-w-[280px] mt-0 p-0"></div>
            {/* Tabs */}
          </div>
          <div className="flex justify-between p-2 mt-1 items-center">
            <EventTabSwitcher
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
          <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-1 mb-2" />
          <EventControl
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            setFilteredAppointment={setFilteredAppointment}
            filteredAppointment={[]}
            selectedStatusProp={selectedStatus}
            setSelectedStatusProp={setSelectedStatus}
          />
        </div>
      </div>
    </div>
  );
}
